import * as React from "react";
import { Header } from "./layout/Header.tsx";
import { FileUploadSection } from "./upload/FileUploadSection.tsx";

export const Prompt: React.FC = () => {
  return (
    <div className="flex overflow-hidden flex-col bg-white">
      <Header />
      <hr className="border-t-0.5 border-black mt-2" />
      <FileUploadSection />
    </div>
  );
};

export default Prompt;